//Reference: EN004

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';


export class StructureOrganizative extends Mappeable {
    ID: number;
    organizationalStructure: any;
    country: any;
    txtName: string;
    typeOrganizationalStructure: any;
    currency: any;
    nmrDaysLab: number;
    nmrHoursLab: number;
    mrkActive: boolean;
    DATE_INSERT: string;
    DATE_UPDATE: string;
    USER_INSERT: string;
    USER_UPDATE: string;

    constructor(o) {
        super(o);
        this.typeOrganizationalStructure = _.isUndefined(this.typeOrganizationalStructure) || _.isNull(this.typeOrganizationalStructure) ? null : this.typeOrganizationalStructure;
        this.organizationalStructure = _.isUndefined(this.organizationalStructure) || _.isNull(this.organizationalStructure) || this.organizationalStructure === '' ? null : this.organizationalStructure;
        this.currency = _.isUndefined(this.currency) || _.isNull(this.currency) ? {} : this.currency;
        this.country = _.isUndefined(this.country) || _.isNull(this.country) ? {} : this.country;
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
    }

    public mapToBack() {
        return {
            country: this.country,
            currency: this.currency,
            mrkActive: this.mrkActive,
            nmrDaysLab: 100,
            organizationalStructure: this.organizationalStructure,
            typeOrganizationalStructure: this.typeOrganizationalStructure,
            txtName: this.txtName,
            txtDescription: "Default",
            nmrHoursLab: this.nmrHoursLab
        }
    }
}